import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PostCardWrap,
  PostCardImage,
  PostCardMeta,
  PostCardTitle,
  PostCardExcerpt,
} from '../styles/BlogStyles';
import {
  getBlogImageUrl,
  getCategoriaLabel,
  formatPostDate,
  estimateReadingTime,
} from '../../services/blogService';
import { MF_BASE } from '../../basePath';

export default function BlogCard({ post, index = 0 }) {
  const navigate = useNavigate();
  if (!post) return null;

  const href = `${MF_BASE}/blog/${post.slug}`;
  const handleClick = (e) => {
    e.preventDefault();
    navigate(href);
  };

  const readingTime = estimateReadingTime(post.conteudo_md);
  const cover = getBlogImageUrl(post.imagem_capa);

  return (
    <PostCardWrap href={href} onClick={handleClick} $i={index}>
      <PostCardImage>
        {cover ? (
          <img src={cover} alt={post.titulo} loading="lazy" />
        ) : (
          <div style={{ width: '100%', height: '100%', background: '#F4F4F2' }} />
        )}
      </PostCardImage>
      <PostCardMeta>
        {post.categoria && <span>{getCategoriaLabel(post.categoria)}</span>}
        {post.categoria && <span>·</span>}
        <span>{readingTime} min de leitura</span>
      </PostCardMeta>
      <PostCardTitle>{post.titulo}</PostCardTitle>
      <PostCardExcerpt>
        {post.resumo || post.subtitulo || ''}
      </PostCardExcerpt>
      {post.published_at && (
        <PostCardMeta style={{ marginTop: 8, color: '#A0A6B2' }}>
          <span>{formatPostDate(post.published_at)}</span>
        </PostCardMeta>
      )}
    </PostCardWrap>
  );
}
